import { FC, useCallback, useEffect, useState } from 'react';

import classNames from 'classnames';

import { ModalContainer } from '../modal-container';
import { InlineLoader } from '../common/inline-loader';
import { useTariffDataUpload } from '../../hooks/useTariffDataUpload';
import { useLazyMeQuery } from '../../services/users.api';

export interface ITariffPurchaseWelcomeProps {
  onClose?: () => void;
}
export const TariffPurchaseWelcome: FC<ITariffPurchaseWelcomeProps> = ({ onClose }) => {
  const [reloading, setReloading] = useState(false);
  const [wasReload, setWasReload] = useState(false);
  const [me, { data, error }] = useLazyMeQuery();
  const { isFetching: isReloading } = useTariffDataUpload(reloading, true);

  const handleClose = useCallback(() => {
    setReloading(true);
  }, []);

  useEffect(() => {
    if (wasReload && !isReloading && data) {
      onClose?.();
    }
    if (isReloading) {
      me();
      setWasReload(true);
    }
  }, [isReloading, onClose, wasReload, reloading, me, data]);

  return (
    <ModalContainer
      width="w-full xs:w-auto xs:max-w-[306px]"
      height="h-full xs:max-h-[513px] min-h-[513px]"
      rounded="xs:rounded-[33px]"
    >
      <div className=" w-full h-full flex flex-col items-center justify-start text-center">
        <p className="font-manrope text-[16px] font-medium pt-20">Спасибо за оплату.</p>
        <p className="font-comfortaa text-[28px] font-bold text-[#C00000] pt-10 leading-none">Подписка активирована!</p>
        <p className="font-manrope text-[16px] font-medium  mt-3">Подробнее в разделе Тарифы.</p>
        <div className="font-manrope text-[18px] font-bold flex flex-col mt-10">
          <p>Вдохновляйте </p>
          <p>изменять себя </p>
          <p>не изменяя себе!</p>
        </div>
        <button
          className={classNames(
            'rounded-[12px] w-[60%]  text-center mt-auto text-[18px] font-semibold font-comfortaa cursor-pointer border-white py-[7px]',
            {
              'bg-black text-white': !isReloading,
              'bg-gray-100 text-gray': isReloading,
            },
          )}
          onClick={handleClose}
          disabled={isReloading}
        >
          {!isReloading && 'Закрыть'}
          {isReloading && <InlineLoader variant="small" />}
        </button>
      </div>
    </ModalContainer>
  );
};
